import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.118 8.037h2.757V5.665c0-1.043.03-2.657.888-3.655C4.667.953 5.908.235 8.043.235c3.477 0 4.942.439 4.942.439l-.69 3.614s-1.148-.294-2.22-.294-2.033.339-2.033 1.288v2.755h4.397l-.307 3.528h-4.09v12.26H2.874v-12.26H.118z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }